<div style="color: red; font-weight: bold">
  I'm sorry but you have tried to access data or operations that you re not authorized for.</div>
<a href="javascript:void(0)"(click)="logout()">Log out and log back in with another account.</a>
